import { render } from "./PollOption.vue?vue&type=template&id=bd7b23f4"
import script from "./PollOption.vue?vue&type=script&lang=js"
export * from "./PollOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__